import { Component, AfterContentChecked, Output, EventEmitter } from '@angular/core';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { SetFocus } from '../../app/shared/setFocus';
import { PartSupplierPruService } from '../partsupplierpru/partsupplierpru.service';
import { PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { ChineseChangeValueService } from '../chinese-change-value.service';

@Component({
    moduleId: module.id,
    selector: 'part-search',
    templateUrl: 'part-search.html',
    providers: [PartSupplierPruService,ChineseChangeValueService],
})
export class PartSearchComponent implements AfterContentChecked {
    searchKeyStrokeDelay = 350;
    searchListDelayTimerDelay = 250;
    showPartSearchSpinner = false;
    PartSearchListDelayTimer: any = null;
    searchPartText = '';
    searchInDescription = false;
    viewPartList = false;
    typeDelayTimer: any = null;
    selectedPart: PartListBE = null;
    searchPartsList: PartListBE[] = null;
    partSearchResult: Array<PartListBE> = [];
    selectedSearchPart: PartListBE = null;
    setFocus: SetFocus = new SetFocus();
    isFocusSet = false;
    showDiv_value:boolean=false;
   /* EnglishToChineseText:Record<string,string>= //function for dictionary of english to chinese word
    {'Search Part':'搜索部分',
    'Search text (part number or description) - min 2 chars. First 25 records will be shown as you type':'搜索文字（ 部件號或描述） -  最少 2  個字元。前 25  條記錄將在您鍵入時顯示',
    'Search in description (note! slow)':'在描述中搜尋（注意！慢)',
    'Partno':'帕特诺',
    'Status':'地位',
    'Cons.areas':'缺點領域',
    'Description':'描述',
    'Missing':'失蹤',
    'Ok':'還行',
    'Add':'加',
    'Cancel':'取消',
    
    };  */

    @Output() partSelectedExecuteCommand: EventEmitter<PartListBE> = new EventEmitter<PartListBE>();

    constructor(
        private partSupplierPruService: PartSupplierPruService,
        private errHandler: ErrorHandlerService,
        public ChineseChangeValueService:ChineseChangeValueService,
    ) { }

    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to('searchPartInput', this.isFocusSet);
    }


    // ----------------------------------------------------------
    // Fetch list data
    // ----------------------------------------------------------
    searchParts() {
       // console.log(this.searchPartText)
       // debugger;
        this.errHandler.emitErrorObject(null);
        this.partSearchResult = [];
        this.showPartSearchSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.partSupplierPruService.searchPart(this.searchPartText, this.searchInDescription)
            .subscribe(returnObject => this.searchPartResponse(returnObject));
    }

    searchPartResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.searchPartResponse', returnObject.ErrorType);
        } else {
            this.partSearchResult = returnObject.DataList;
        }
        this.showPartSearchSpinner = false;
    }


    // ----------------------------------------------------------
    // Search  part
    // ----------------------------------------------------------
    searchPartTextChanged() {
        const that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchPartText.length >= 2) {
            that.viewPartList = true;

            // If this.typeDelayTimer is not nulll then the
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null) {
                clearInterval(that.typeDelayTimer);
            }

            that.typeDelayTimer = setInterval(function () {
                that.searchParts();
            }, that.searchKeyStrokeDelay);
        } else {
            that.viewPartList = false;
            clearInterval(this.typeDelayTimer);
        }
    }

    startPartSearchListWithDelay() {
        const that = this;

        if (!that.viewPartList) {
            clearInterval(this.PartSearchListDelayTimer);
            return;
        }

        if (that.PartSearchListDelayTimer != null) {
            clearInterval(that.PartSearchListDelayTimer);
        }

        that.PartSearchListDelayTimer = setInterval(function () {
            that.finalizeHidePartSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    finalizeHidePartSearchListWithDelay() {
        this.viewPartList = false;
        clearInterval(this.PartSearchListDelayTimer);
    }

    hidePartSearchListWithDelay() {
        clearInterval(this.PartSearchListDelayTimer);
        this.startPartSearchListWithDelay();
    }

    showPartSearchList() {
        if (this.searchPartText.length >= 2) {
            clearInterval(this.PartSearchListDelayTimer);
            this.viewPartList = true;
        }
    }

    setSearchSelectedPart(part: PartListBE): void {
        this.selectedSearchPart = part;
    }

    onPressOk() {
        this.partSelectedExecuteCommand.emit(this.selectedSearchPart);
    }

    isPartInSearchListChecked(partId: number): boolean {
        return this.selectedSearchPart !== null
            && this.selectedSearchPart.Id === partId;
    }

    isSearchPartSelected(): boolean {
        return this.selectedSearchPart !== null;
    }

    closeDlg() {
        this.partSelectedExecuteCommand.emit(null);
    }

    onSingleAddPart(event) {
       
        if (event.key === "Enter" && this.partSearchResult.length === 1) {
            this.partSelectedExecuteCommand.emit(this.partSearchResult[0]);
        }
    }

    onSelectedAddPart(event) {
        if (this.isSearchPartSelected && event.key === "Enter") {
            this.onPressOk();
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/part-search/part-search.component.ts